// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perfil-industry {
  width: 100%;
}
.perfil-industry .color-purple {
  color: #7A6BE8;
}
.perfil-industry .color-blue {
  color: #41C8FF;
}
.perfil-industry .btnPerfilIndustry {
  background-color: #7A6BE8;
  color: white;
}
.perfil-industry .btnPerfilIndustry:hover {
  background-color: #5F52C4;
  color: white;
}
.perfil-industry .content-img {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.perfil-industry .content-img img {
  width: 100%;
  border-radius: 5px;
}
.perfil-industry .input-group-text {
  background: none;
  border: none;
  padding: 0.375rem 0.6rem;
}
.perfil-industry .perfilIndustry-input {
  border: none;
  width: 100%;
  margin: 0;
  height: auto;
  border-radius: 0;
}
.perfil-industry select.perfilIndustry-input {
  border-radius: 0 !important;
}
.perfil-industry select.perfilIndustry-input.form-control:focus {
  z-index: 0;
}
.perfil-industry select.perfilIndustry-input .bg-gray {
  background: #444258;
}
.perfil-industry .info {
  display: flex;
  align-items: center;
}
.perfil-industry .info svg {
  margin: 0 10px;
}
.perfil-industry .data-company {
  position: relative;
  display: block;
}
.perfil-industry .data-company li {
  margin-bottom: 6px;
}
.perfil-industry .list-icons {
  display: flex;
  margin: 0;
  padding: 0;
  z-index: 2;
}
.perfil-industry .list-icons li {
  border-radius: 50rem;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: -20px 3px;
  border: 5px solid white;
  cursor: pointer;
  filter: grayscale(85%);
}
.perfil-industry .list-icons li:nth-child(1) {
  background: #0073b1;
}
.perfil-industry .list-icons li:nth-child(2) {
  background: #1d9bf0;
}
.perfil-industry .list-icons li:nth-child(3) {
  background: #0b64a4;
}
.perfil-industry .list-icons li:nth-child(4) {
  background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 3%, #fd5949 45%, #d6249f 100%);
}
.perfil-industry .list-icons li:nth-child(5) {
  background: rgb(27, 116, 228);
}
.perfil-industry .list-icons li:hover {
  transform: scale(1.1);
}
.perfil-industry .list-icons li svg {
  fill: white;
  font-size: 30px;
}
.perfil-industry .box-images-perfil {
  display: flex;
  width: 65px;
  margin-right: 25px;
}
.perfil-industry .box-images-perfil img {
  margin-left: -15px;
  width: 40px;
  height: 40px;
  border: 4px solid white;
  border-radius: 50rem;
  order: 3;
}
.perfil-industry .content-description span {
  font-weight: bold;
}
.perfil-industry .product input {
  width: 100%;
  border-radius: 5px;
}
.perfil-industry .product button {
  background: #6d68aa;
  color: white;
  padding: 5px 0;
  width: 100px;
  height: 36px;
  border-radius: 5px;
}

@media screen and (max-width: 800px) {
  .perfil-industry {
    margin-top: -20px;
  }
  .perfil-industry .content-img {
    height: 250px;
    width: 250px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Views/Services/Components/PerfilIndustry/perfilIndustry.sass"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;AACI;EACI,cAAA;AACR;AAAI;EACI,cAAA;AAER;AACI;EACI,yBAAA;EACA,YAAA;AACR;AAAQ;EACI,yBAAA;EACA,YAAA;AAEZ;AAAI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAER;AAAQ;EACI,WAAA;EACA,kBAAA;AAEZ;AAAI;EACI,gBAAA;EACA,YAAA;EACA,wBAAA;AAER;AAAI;EACI,YAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;AAER;AADI;EACI,2BAAA;AAGR;AAFQ;EACI,UAAA;AAIZ;AAFQ;EACI,mBAAA;AAIZ;AAFI;EACI,aAAA;EACA,mBAAA;AAIR;AAFQ;EACI,cAAA;AAIZ;AAFI;EACI,kBAAA;EACA,cAAA;AAIR;AAFI;EACI,kBAAA;AAIR;AAFI;EACI,aAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AAIR;AAFQ;EACI,oBAAA;EACA,WAAA;EACA,YAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,sBAAA;AAGZ;AADY;EACI,mBAAA;AAGhB;AADY;EACI,mBAAA;AAGhB;AADY;EACI,mBAAA;AAGhB;AADY;EACI,kGAAA;AAGhB;AADY;EACI,6BAAA;AAGhB;AADY;EACI,qBAAA;AAGhB;AAFY;EACI,WAAA;EACA,eAAA;AAIhB;AAFI;EACI,aAAA;EACA,WAAA;EACA,kBAAA;AAIR;AAHQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,QAAA;AAKZ;AAFQ;EACI,iBAAA;AAIZ;AADQ;EACI,WAAA;EACA,kBAAA;AAGZ;AADQ;EACI,mBAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AAGZ;;AADA;EACI;IACI,iBAAA;EAIN;EAFM;IAEI,aAAA;IACA,YAAA;EAGV;AACF","sourcesContent":[".perfil-industry\n    width: 100%\n\n    .color-purple\n        color: #7A6BE8\n    .color-blue\n        color: #41C8FF\n    .color-green\n\n    .btnPerfilIndustry\n        background-color: #7A6BE8\n        color: white\n        &:hover\n            background-color: #5F52C4\n            color: white\n\n    .content-img\n        display: flex\n        justify-content: center\n        align-items: center\n        height: 100%\n\n        & img\n            width: 100%\n            border-radius: 5px\n\n    .input-group-text\n        background: none\n        border: none\n        padding: 0.375rem 0.60rem\n\n    .perfilIndustry-input\n        border: none\n        width: 100%\n        margin: 0\n        height: auto\n        border-radius: 0\n    & select.perfilIndustry-input\n        border-radius: 0 !important\n        &.form-control:focus\n            z-index: 0\n\n        & .bg-gray\n            background: #444258\n\n    .info\n        display: flex\n        align-items: center\n\n        & svg\n            margin: 0 10px\n\n    .data-company\n        position: relative\n        display: block\n\n    .data-company li\n        margin-bottom: 6px\n\n    .list-icons\n        display: flex\n        margin: 0\n        padding: 0\n        z-index: 2\n\n        & li\n            border-radius: 50rem\n            width: 60px\n            height: 60px\n\n            display: flex\n            justify-content: center\n            align-items: center\n            margin: -20px 3px\n            border: 5px solid white\n            cursor: pointer\n            filter: grayscale(85%)\n\n            &:nth-child(1)\n                background: #0073b1\n\n            &:nth-child(2)\n                background: #1d9bf0\n\n            &:nth-child(3)\n                background: #0b64a4\n\n            &:nth-child(4)\n                background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 3%, #fd5949 45%, #d6249f 100%)\n\n            &:nth-child(5)\n                background: rgb(27, 116, 228)\n\n            &:hover\n                transform: scale(1.1)\n            & svg\n                fill: white\n                font-size: 30px\n\n    & .box-images-perfil\n        display: flex\n        width: 65px\n        margin-right: 25px\n        img\n            margin-left: -15px\n            width: 40px\n            height: 40px\n            border: 4px solid white\n            border-radius: 50rem\n            order: 3\n\n    & .content-description\n        & span\n            font-weight: bold\n\n    & .product\n        input\n            width: 100%\n            border-radius: 5px\n\n        button\n            background: #6d68aa\n            color: white\n            padding: 5px 0\n            width: 100px\n            height: 36px\n            border-radius: 5px\n\n@media screen and (max-width: 800px)\n    .perfil-industry\n        margin-top: -20px\n\n        .content-img\n\n            height: 250px\n            width: 250px\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
